<template>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Google WebHook">
        <v-card-component>
         <v-row>
          <v-col cols="12" md="4" sm="4">
            <v-label>Campaign ID<span class="error--text ml-1">*</span></v-label>
            <v-text-field v-model.trim="selectedCampaignid" placeholder="--Insert Campaign ID--"></v-text-field>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-label>Franchisee ID<span class="error--text ml-1">*</span></v-label>
            <v-autocomplete required clearable v-model="selectedFranchiseeid" :items="franchisees" key="id" item-value="id" item-text="companyName">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-btn color="primary" class="ml-10 mt-9" @click="save()">Add</v-btn>
          </v-col>
         </v-row>
        </v-card-component>
        <v-spacer></v-spacer>
        <v-data-table  item-key="id" :headers="headers"
        :items="googleWebHookList" >
        <template v-slot:item.state="{ item }">
          <span>{{ item.state?item.state:'-' }}</span>
        </template>
        <template v-slot:item.isActive="{ item }">
          <span v-if="item.isActive === true" class="success--text ml-1">ACTIVE</span>
          <span v-if="item.isActive === false" class="error--text ml-1">INACTIVE</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <span><v-btn title="Restore" small outlined class="px-2 ml-1 ma-1" color="green" v-if="item.deletedAt" @click="restoreCampaignID(item)"><v-icon small> mdi-restore</v-icon>
                </v-btn>
                <v-btn title="Delete" small outlined class="px-2 ml-1 ma-1" color="pink" v-if="!item.deletedAt" @click="deleteCampaignID(item)"><v-icon small> mdi-delete</v-icon>
                </v-btn>
              </span>
        </template>
        </v-data-table>
        </material-card>
    </v-container>
</template>
<script>
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
// import stores from '@/stores'
import _ from 'lodash'

export default {
  name: 'googleWebHook',
  components: { VCardComponent, MaterialCard },
  data () {
    return {
      title: 'googleWebHook',
      headers: [
        { text: 'Sr No', value: 'srno', align: 'center', sortable: true },
        { text: 'Campaign ID', value: 'campaignID', align: 'center', sortable: true },
        { text: 'Franchisee ID', value: 'franchiseeID', align: 'center', sortable: true },
        { text: 'State', value: 'state', align: 'center', sortable: true },
        { text: 'Status', value: 'isActive', align: 'center' },
        { text: 'Action', value: 'actions', align: 'center' }
      ],
      selectedFranchiseeid: '',
      selectedCampaignid: '',
      franchisees: [{ id: '', companyName: 'Select Franchisee' }],
      googleWebHookList: [],
      selectedState: ''
    }
  },
  async created () {
    await this.getFranchiseeList()
    await this.getGoogleCampaignList()
  },
  methods: {
    getFranchiseeList: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/franchisee/active`
        )
        const data = response.data
        this.franchisees = [{ id: '', companyName: '--Select Franchisee--' }].concat(data.rows)
        this.franchisees.forEach(e => {
          if (e.id) {
            if (e.id.toString().length === 1) {
              e.companyName = `${'(00' + e.id + ')'} ` + e.companyName
            } else if (e.id.toString().length === 2) {
              e.companyName = `${'(0' + e.id + ')'} ` + e.companyName
            } else {
              e.companyName = `${'(' + e.id + ')'} ` + e.companyName
            }
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    getGoogleCampaignList: async function () {
      try {
        let webHookList = []
        const response = await http.get(
          `${constants.API_URL}/api/google-webHook`
        )
        if (response) {
          _.map(response.data, (item) => {
            webHookList.push(item)
          })
        }
        this.googleWebHookList = webHookList
        _.forEach(this.googleWebHookList, (item, index) => {
          item.srno = ++index
        })
      } catch (e) {
        console.log(e)
      }
    },
    deleteCampaignID: async function (item) {
      try {
        let that = this
        this.$dialog.warning({
          title: item.isActive === true ? 'Deactivate' : 'Activate',
          text: 'Are you sure you want to delete this campaign ID?',
          actions: {
            false: {
              text: 'No'
            },
            true: {
              color: 'success',
              text: 'Yes',

              handle: async () => {
                try {
                  this.isLoading = true
                  return await http.delete(`${constants.API_URL}/api/webHook/${item.campaignID}`).then(() => {
                    that.getGoogleCampaignList()
                    this.isLoading = false
                    return this.$dialog.info({
                      title: 'Success',
                      text: 'Deactivated campaign ID successfully.'

                    })
                  })
                } catch (httpException) {
                  console.warn('Error while deleting campaign ID', httpException.message)
                  this.isLoading = false

                  return this.$dialog.error({
                    title: 'Error',
                    text: 'Error while deleting campaign ID'
                  })
                } finally {
                  this.isLoading = false
                }
              }
            } }
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      }
    },
    restoreCampaignID: async function (item) {
      try {
        let that = this
        this.$dialog.warning({
          title: item.isActive === true ? 'Deactivate' : 'Activate',
          text: 'Are you sure you want to restore this campaign ID?',
          actions: {
            false: {
              text: 'No'
            },
            true: {
              color: 'success',
              text: 'Yes',

              handle: async () => {
                try {
                  this.isLoading = true
                  return await http.put(`${constants.API_URL}/api/webHook/${item.campaignID}/restore`).then(() => {
                    that.getGoogleCampaignList()
                    this.isLoading = false
                    return this.$dialog.info({
                      title: 'Success',
                      text: 'Campaign ID successfully restored.'

                    })
                  })
                } catch (httpException) {
                  console.warn('Error while restoring campaign ID', httpException.message)
                  this.isLoading = false

                  return this.$dialog.error({
                    title: 'Error',
                    text: 'Error while restoring campaign ID'
                  })
                } finally {
                  this.isLoading = false
                }
              }
            } }
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(`${errorMessage}`)
      }
    },
    save: async function () {
      try {
        if (!this.selectedCampaignid && !this.selectedFranchiseeid) {
          return this.errMsg(`Campaign ID & Franchisee ID can not be empty.`)
        }
        if (!this.selectedFranchiseeid) {
          return this.errMsg(`Franchisee ID can not be empty.`)
        }
        if (!this.selectedCampaignid) {
          return this.errMsg(`Campaign ID can not be empty.`)
        }
        if (this.selectedFranchiseeid) {
          _.forEach(this.franchisees, (item) => {
            if (this.selectedFranchiseeid === item.id) {
              this.selectedState = item.state
            }
          })
        }
        let payload = {
          campaignID: this.selectedCampaignid,
          franchiseeID: this.selectedFranchiseeid,
          state: this.selectedState,
          isActive: true
        }
        let result = await http.post(`${constants.API_URL}/api/add-google-web-hook`, payload)
        if (result) {
          this.resetAll()
          return this.okMsg('Data saved successfully.')
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(`${errorMessage}`)
      } finally {
        this.resetAll()
      }
    },
    resetAll: function () {
      this.selectedCampaignid = ''
      this.selectedFranchiseeid = ''
      this.getGoogleCampaignList()
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
